
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.2 19.2l-7.9-6V5.8h-6.5v2.5L25 .8.8 19.2l1.5 2 1.4-1.1v27.1h42.5V20.1l1.4 1.1 1.6-2zM37.3 8.3h1.5v3l-1.5-1.1V8.3zm-7.4 36.5h-9.7V28.3h9.7v16.5zm13.9 0H32.3v-19H17.6v19H6.3V18.2L25 4l18.8 14.3v26.5z"}})])
          )
        }
      }
    